// modules/PlanButton.js
import React from 'react';
import { Link } from 'react-router';

class PlanButton extends React.Component {
	constructor(props) {
        super(props);
        let active = false;
        if(this.props.buttonlink === this.props.activePath || this.props.buttonlink+"/" === this.props.activePath) {
        	active = true;
        }
        this.state = { active: active };

		this.showBHoverEvent       = this.showBHoverEvent.bind(this);
		this.hideBHoverEvent       = this.hideBHoverEvent.bind(this);
		this.showBHoverAreas       = this.showBHoverAreas.bind(this);
		this.hideBHoverAreas       = this.hideBHoverAreas.bind(this);

        this.props.messenger.subscribe("a_"+this.props.id, this.showBHoverEvent);
        this.props.messenger.subscribe("c_"+this.props.id, this.hideBHoverEvent);
    }

	componentWillUnmount() {
		this.props.messenger.remove("a_"+this.props.id);
		this.props.messenger.remove("c_"+this.props.id);
	}

    showBHoverEvent() {
	    this.setState({active:true});
    }

    hideBHoverEvent() {
		if(this.props.buttonlink !== this.props.activePath) {
            this.setState({active: false});
        }
    }

    showBHoverAreas() {
		if(this.props.id !== null) {
            this.props.messenger.publish("a_" + this.props.id, {});
        }
	}

	hideBHoverAreas() {
        if(this.props.id !== null) {
            this.props.messenger.publish("c_" + this.props.id, {});
        }
	}

	lotCount() {
        if(this.props.lotCountTxt !== undefined && this.props.lotCountTxt !== "") {
            return (<span className="lot-small-red-font"> {'(' + this.props.lotCountTxt + ')'}</span>);
        }
	}

	render() {
		let divclasses = "p-a-1 brd-top";
		if (this.state.active) {
		    divclasses += " active";
	    }
		return (
			<Link to={this.props.buttonlink}>
				<li className={divclasses} id={this.props.id} onMouseEnter={this.showBHoverAreas} onMouseLeave={this.hideBHoverAreas}>
					<span>{this.props.children}</span>
                    {this.lotCount()}
				</li>
			</Link>
		);
	}
}

export default PlanButton;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanButton.js
 **/